import React, { Component } from 'react'
import loadsStore from '../../stores/loads-store'

class LoadsFooter extends Component {
    constructor() {
        super();

    }
    createCoachJump = () => {
        //alert("loadNum: " + loadNum);
        loadsStore.createCoachJump(this.props.loadObj.loadNum, {});
    };
    createAffJump = (type) => {
        let { loadObj } = this.props;
        //alert("loadNum: " + loadNum);
        var postBody = { type: type };

        postBody.studentPackageId = loadsStore.getDefaultStudentPackageId(type);

        loadsStore.createAffJump(loadObj.loadNum, postBody);
    };
    render() {
        let { usingWaitlist, loadObj, isCompleted, IsdisplayOnly, toggleFooterClass, toggleClass, createFunJump, createTeamJump, disabled, backgroundColorFooter } = this.props;
        var studentPackageTypes = loadsStore.getStudentPackageTypes();

        var funJumpTypes = loadsStore.getFunJumpTypes();

        var funJumpButtons = funJumpTypes.map((type, i) => {

            return (<div className="jump-create " onClick={() => createFunJump("centercard" + loadObj.loadNum, type)} ddata-key={loadObj.loadNum} disabled={loadObj.closed}>
                <i className="fa fa-plus" /> <strong>{type}</strong>
            </div>)
        });

        var createStudentButtons = studentPackageTypes.map((p, i) => {
            var affSelfManifestSetting = loadsStore.getAffSelfManifestSetting().value;
            //alert(affSelfManifestSetting);
            if (affSelfManifestSetting === "yes") {
                if (p === "IAD") {
                    return (
                        <div
                            key={`${i}_createStudentButtons`}
                            className="jump-create"
                            onClick={() => this.createIadJump(p)}
                            disabled={this.props.disabled}
                        >
                            <i className="fa fa-plus" /> <strong>{p?.toUpperCase()}</strong>
                        </div>
                    );
                }
                else {
                    return (
                        <div
                            key={`${i}_createStudentButtons`}
                            className="jump-create"
                            onClick={() => this.createAffJump(p)}
                            disabled={this.props.disabled}
                        >
                            <i className="fa fa-plus" /> <strong>{p?.toUpperCase()}</strong>
                        </div>
                    );
                }

            }
        });
        return (
            (usingWaitlist === loadObj.isWaitlist) && !isCompleted && !IsdisplayOnly && !loadObj.closed && loadObj.totalJumpers < loadObj.capacity ?
                <div className="centerDivFooter" style={{ background: backgroundColorFooter }}>
                    <div className="footerBtn">
                        <button onClick={() => toggleFooterClass()}>
                            <i className="fa fa-bars" />
                        </button>
                    </div>
                    <div className={`innerFooter ${toggleClass ? 'opened' : ''}`}>
                        {/* <button className="btn lightBlueButton jump-create" style={{ fontSize: "22px" }} onClick={() => this.createFunJump("centercard" + loadObj.loadNum)} data-key={loadObj.loadNum} type="submit" disabled={loadObj.closed}
                                              style={{ borderRadius: '100px', fontSize: '1.2rem !important' }}>
                                              <i className="fa fa-plus" /> <strong>FUN JUMP</strong>
                                          </button> */}
                        {window.ENV?.teamsFeatureEnable && <div className="jump-create " onClick={() => createTeamJump()} ddata-key={loadObj.loadNum} disabled={loadObj.closed}>
                            <i className="fa fa-plus" /> <strong>Team</strong>
                        </div>}
                        
       
                        {funJumpButtons}
                        {loadsStore.getCoachSelfManifestSetting().value == "yes" ?
                            <div
                                className="jump-create "
                                onClick={() => this.createCoachJump()}
                                disabled={disabled}
                            >
                                <i className="fa fa-plus" />
                                <strong>COACH JUMP</strong>
                            </div> : null
                        }
                        {createStudentButtons}
                    </div>
                </div>
                :
                <div className="mBottomMain" style={{ background: backgroundColorFooter, height: '20px' }}></div>
        )
    }
}
export default LoadsFooter;
